import { Link } from "react-router-dom";
import useSeo from "@/seo/useSeo";
import { useI18n, LEGAL_TITLES } from "@/i18n";
import { LEGAL } from "@/i18n/legal";

export default function Legal({ page }) {
  const { lang, t } = useI18n();
  useSeo(`/${page}`);
  const titles = LEGAL_TITLES[lang] || LEGAL_TITLES.fr;
  const blocks = (LEGAL[lang] || LEGAL.fr)[page];
  return (
    <div className="mx-auto max-w-4xl px-6 py-20 sm:px-10" data-testid={`legal-${page}`}>
      <p className="eyebrow">{t("legal.eyebrow")}</p>
      <h1 className="display-xl mt-6 text-5xl text-bone sm:text-6xl">{titles[page]}</h1>
      <div className="mt-14 divide-y divide-white/10 border-y border-white/10">
        {blocks.map(([ti, d]) => (
          <section key={ti} className="py-8">
            <h2 className="font-display text-3xl text-bone">{ti}</h2>
            <p className="mt-3 text-sm leading-loose text-bone/75">{d}</p>
          </section>
        ))}
      </div>
      <div className="mt-12 flex flex-wrap gap-6 text-[11px] uppercase tracking-[0.2em] text-bone/70">
        {Object.entries(titles).map(([k, v]) => (
          <Link key={k} to={`/${k}`} className="link-underline hover:text-brass">{v}</Link>
        ))}
      </div>
    </div>
  );
}
